import { render } from "./systemIndex.vue?vue&type=template&id=044091fc"
import script from "./systemIndex.vue?vue&type=script&lang=js"
export * from "./systemIndex.vue?vue&type=script&lang=js"

import exportComponent from "G:\\workBench\\my_server_project\\eventvue\\myEvents\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__